import React from "react";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";
import Image from "next/image";

const UspPoweredByDesktop = () => {
  return (
    <div className="lg:container flex flex-col md:flex-row items-center justify-between gap-32 bg-white p-6">
      <div className="w-full flex justify-between items-center">
        <div className="md:w-[400px]">
          <h2 className="text-[30px] md:text-[72px] 2xl:text-[78px] font-bold text-black mb-4 leading-[116%] tracking-[-2.88px]">
            Powered by
            <br /> Miles
          </h2>
        </div>
        <div
          className="w-[400px] p-4 border border-white rounded-2xl"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
            boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
            backdropFilter: "blur(28px)",
          }}
        >
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
            alt="star group"
            width={34}
            height={38}
            className="absolute top-1 left-0"
          />
          <GlobalForm
            course="USP"
            courseId={3}
            formHeading={FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR}
            formType="page"
            isAStepperForm={true}
            pageType="accounting page"
            subCategory={FinanceAndAccountingSubcategory.USP}
            submitButtonName="Start Your Journey"
            successMessage={SuccessMessageType.ACCOUNTING}
            verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
            showSVG={false}
            darkBackground={false}
          />
        </div>
      </div>
    </div>
  );
};

export default UspPoweredByDesktop;
